import { connectRange } from "instantsearch.js/es/connectors";
import { useState } from "nuxt/app";
import { provide, ref } from "vue";
export const useAisRangeInputRenderState = () => useState(
  "ais_range_render_state",
  () => ({})
);
export const useAisRangeInput = (widgetParams, id = "") => {
  const stateRef = ref();
  const rangeRenderState = useAisRangeInputRenderState();
  const renderRange = (renderState, isFirstRender) => {
    stateRef.value = renderState;
    if (import.meta.client) {
      rangeRenderState.value[widgetParams.attribute] = renderState;
    }
    if (isFirstRender) {
      provide(`rangeInput-${id}`, stateRef);
    }
    return () => null;
  };
  const customRange = connectRange(renderRange);
  return {
    ...customRange(widgetParams),
    $$widgetParams: widgetParams,
    $$widgetId: id
  };
};
